import { AuditLogAPI } from "../api"
import { Invoice, Receipt, Contract, AreaInterest } from "../classes"
import i18n from '@/plugins/vue-i18n';
export class AuditLog {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
      this.detail = ""
      if (
        data.type == 'send_invoice' ||
        data.type == 'unsend_invoice' ||
        data.type == 'update_invoice' ||
        data.type == 'cancel_invoice'
      ) {
        this.detail = `${i18n.t('invoice.invoice_number_only')}: ${data.newData.documentId || "-"}`
      } else if (
        data.type == 'pay_receipt' ||
        data.type == 'unpay_receipt'
      ) {
        this.detail = `${i18n.t('bill.receipt_id')}: ${data.newData.documentId}`
      } else if (
        data.type == 'create_contract' ||
        data.type == 'update_contract' ||
        data.type == 'change_customer_contract' ||
        data.type == 'renew_contract' ||
        data.type == 'close_contract'
      ) {
        this.detail = `${i18n.t('contract.contract_number_only')}: ${data.newData.contractId}`
      } else if (
        data.type == 'add_contract_area' ||
        data.type == 'remove_contract_area' ||
        data.type == 'create_contract_document' ||
        data.type == 'update_contract_document' ||
        data.type == 'remove_contract_document'
      ) {
        if(data.newData.contract){
          this.detail = `${i18n.t('contract.contract_number_only')}: ${data.newData.contract.contractId}`
        }else if(data.newData.contractCheckout){
          this.detail = `${i18n.t('area.checkout_document_id')}: ${data.newData.contractCheckout.documentId}`
        }else if(data.newData.areaInterest){
          let areaInterest = new AreaInterest(data.newData.areaInterest)
          this.detail = `${i18n.t('market.customer_name_and_company_not_space')}: ${areaInterest.getCustomerName}`
        }
      } else if (
        data.type == 'change_name_project'
      ) {
        this.detail = `${i18n.t('project.project_name_only')}: ${data.newData.name}`
      } else if (
        data.type == 'change_name_market'
      ) {
        this.detail = `${i18n.t('project.market_name_only')}: ${data.newData.name}`
      } else if (
        data.type == 'edit_area_product'
      ) {
        this.detail = `${i18n.t('area.space')}: ${data.newData.name}`
      }
    }
    let hashTypeString = {
      "send_invoice": i18n.t('bill.send_bill'),
      "update_invoice": i18n.t('bill.edit_bill'),
      "unsend_invoice": i18n.t('bill.cancel_send_bill'),
      "pay_receipt": i18n.t('payment.pay'),
      "unpay_receipt": i18n.t('payment.cancel_pay_money'),
      "create_contract": i18n.t('contract.create_contract'),
      "update_contract": i18n.t('contract.edit_contract'),
      "add_contract_area": i18n.t('area.add_stall'),
      "remove_contract_area": i18n.t('contract.reduce_area'),
      "renew_contract": i18n.t('contract.renew_contract'),
      "close_contract": i18n.t('contract.close_contract'),
      "create_contract_document": i18n.t('contract.add_contract_document'),
      "update_contract_document": i18n.t('customer.edit_document_set'),
      "remove_contract_document": i18n.t('customer.delete_document_set'),
      "change_customer_contract": i18n.t('contract.transfer_contract'),
      "change_name_project": i18n.t('project.change_project_name'),
      "change_name_market": i18n.t('market.change_market_name'),
      "edit_area_product": i18n.t('product.edit_product_only'),
      "cancel_invoice": i18n.t('bill.cancel')
    }
    this.typeString = hashTypeString[this.type] || ""
    let _newData
    let _oldData

    this.newObject = {}
    this.oldObject = {}
    this.headData = {}

    if (this.type == "send_invoice" || this.type == "unsend_invoice" || this.type == "update_invoice" || this.type == "cancel_invoice") {
      _newData = new Invoice(this.newData)
      _oldData = new Invoice(this.oldData)

      this.headData = {
        invoiceId: _newData.objectId,
        documentId: _newData.documentId
      }
    } if (this.type == "update_contract") {
      _newData = new Contract(this.newData)
      _oldData = new Contract(this.oldData)
    } else if (this.type == "pay_receipt") {
      _newData = new Receipt(this.newData)
      _oldData = new Receipt(this.oldData)
    }

    if (this.type == "send_invoice" || this.type == "unsend_invoice") {
      this.newObject = {
        invoiceId: _newData.objectId,
        documentId: _newData.documentId
      }
    } else if (this.type == "update_invoice") {

      this.newObject.date = _newData.date
      this.oldObject.date = _oldData.date

      this.newObject.dueDate = _newData.dueDate
      this.oldObject.dueDate = _oldData.dueDate

      this.newObject.customerData = {}
      this.oldObject.customerData = {}

      this.newObject.customerData.name = _newData.customerData.name
      this.oldObject.customerData.name = _oldData.customerData.name

      this.newObject.customerData.address = _newData.customerData.address
      this.oldObject.customerData.address = _oldData.customerData.address
      
      this.newObject.customerData.taxId = _newData.customerData.taxId
      this.oldObject.customerData.taxId = _oldData.customerData.taxId

      this.newObject.customerData.branchCode = _newData.customerData.branchCode
      this.oldObject.customerData.branchCode = _oldData.customerData.branchCode

      this.newObject.customerData.branchName = _newData.customerData.branchName
      this.oldObject.customerData.branchName = _oldData.customerData.branchName

      this.newObject.customerData.tel = _newData.customerData.tel
      this.oldObject.customerData.tel = _oldData.customerData.tel

      this.newObject.customerData.email = _newData.customerData.email
      this.oldObject.customerData.email = _oldData.customerData.email

      this.newObject.isVatInclusive = _newData.isVatInclusive
      this.oldObject.isVatInclusive = _oldData.isVatInclusive

      this.newObject.items = _newData.items || []
      this.oldObject.items = _oldData.items || []

      this.newObject.totalValue = _newData.totalValue
      this.oldObject.totalValue = _oldData.totalValue
    } else if (this.type == "update_contract") {
      if (_oldData.businessName != _newData.businessName) {
        this.newObject.businessName = _newData.businessName
        this.oldObject.businessName = _oldData.businessName
      }
      if (_oldData.stallType != _newData.stallType) {
        this.newObject.stallType = _newData.stallType
        this.oldObject.stallType = _oldData.stallType
      }
      if (JSON.stringify(_oldData.startDate) != JSON.stringify(_newData.startDate)) {
        this.newObject.startDate = _newData.startDate ? _newData.startDate.iso : null
        this.oldObject.startDate = _oldData.startDate ? _oldData.startDate.iso : null
      }
      if (JSON.stringify(_oldData.endDate) != JSON.stringify(_newData.endDate)) {
        this.newObject.endDate = _newData.endDate ? _newData.endDate.iso : null
        this.oldObject.endDate = _oldData.endDate ? _oldData.endDate.iso : null
      }
      if (_oldData.contractDays != _newData.contractDays) {
        this.newObject.contractDays = _newData.contractDays
        this.oldObject.contractDays = _oldData.contractDays
      }
      if (JSON.stringify(_oldData.billingData) != JSON.stringify(_newData.billingData)) {
        _oldData.billingData = _oldData.billingData || {}
        _newData.billingData = _newData.billingData || {}

        this.newObject.billingData = {}
        this.oldObject.billingData = {}

        if (_oldData.billingData.name != _newData.billingData.name) {
          this.newObject.billingData.name = _newData.billingData.name
          this.oldObject.billingData.name = _oldData.billingData.name
        }
        if (_oldData.billingData.address != _newData.billingData.address) {
          this.newObject.billingData.address = _newData.billingData.address
          this.oldObject.billingData.address = _oldData.billingData.address
        }
        if (_oldData.billingData.taxId != _newData.billingData.taxId) {
          this.newObject.billingData.taxId = _newData.billingData.taxId
          this.oldObject.billingData.taxId = _oldData.billingData.taxId
        }
        if (_oldData.billingData.branchCode != _newData.billingData.branchCode) {
          this.newObject.billingData.branchCode = _newData.billingData.branchCode
          this.oldObject.billingData.branchCode = _oldData.billingData.branchCode
        }
        if (_oldData.billingData.branchName != _newData.billingData.branchName) {
          this.newObject.billingData.branchName = _newData.billingData.branchName
          this.oldObject.billingData.branchName = _oldData.billingData.branchName
        }
        if (_oldData.billingData.tel != _newData.billingData.tel) {
          this.newObject.billingData.tel = _newData.billingData.tel
          this.oldObject.billingData.tel = _oldData.billingData.tel
        }
        if (_oldData.billingData.email != _newData.billingData.email) {
          this.newObject.billingData.email = _newData.billingData.email
          this.oldObject.billingData.email = _oldData.billingData.email
        }
      }
      if (JSON.stringify(_oldData.startMeterData) != JSON.stringify(_newData.startMeterData)) {
        if (_newData.startMeterData) this.newObject.startMeterData = _newData.startMeterData
        if (_oldData.startMeterData) this.oldObject.startMeterData = _oldData.startMeterData
      }
    }
  }
  static async getAuditLogBetweenDateByMarket(formData) {
    const { data } = await AuditLogAPI.getAuditLogBetweenDateByMarket(formData);
    return data.result.map(item => new AuditLog(item));
  }
}